let initialState = {
	stocksByLocations: [],
};

const StocksByLocationsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_STOCKS_BY_LOCATIONS':
			return {
				...state,
				stocksByLocations: action.payload,
			};
		default:
			return state;
	}
};

export { StocksByLocationsReducer };
